import { z } from 'zod';

import type { FilterValue } from '../createColumnBuilder';

export const numberRangeFilterSchema = z.tuple([z.number(), z.number()]);

export function isFilterApplied(value: FilterValue): boolean {
  if (typeof value === 'boolean') {
    return true;
  }
  if (Array.isArray(value)) {
    if (value[0] === null && value[1] === null) {
      return false;
    }
    return value?.length > 0;
  }
  if (typeof value === 'number') {
    return true;
  }
  if (value === null) {
    return false;
  }
  return value?.length > 0;
}
